module.exports = __webpack_public_path__ + "static/presidents-message-273bde2ef073cd7f9cc3f1b0c50f3210.jpg";